import axiosClient from '@/config/api/axios'
import { AUTOMATIONS } from '@/config/api/endpoints'

export async function fetchActivationRequirements(automationId) {
  const { data } = await axiosClient.get(`${AUTOMATIONS}/${automationId}/activation-requirements`)
  return {
    cards: data.approval_cards ?? [],
    blockers: data.blockers ?? [],
    status: data.status,
    semanticPlan: data.semantic_plan ?? null,
  }
}

export async function prepareAutomation(automationId) {
  const { data } = await axiosClient.post(`${AUTOMATIONS}/${automationId}/prepare`)
  return data
}

export async function activateWithGrants({ automationId, cards, days }) {
  const expiresAt = new Date(Date.now() + days * 86_400_000).toISOString()
  for (const card of cards) {
    await axiosClient.post(`${AUTOMATIONS}/${automationId}/grants`, {
      action_id: card.action_id, trigger_ids: card.trigger_ids,
      allowed_inputs: card.allowed_inputs,
      max_writes_per_occurrence: card.max_writes_per_occurrence,
      expires_at: expiresAt,
    })
  }
  const { data } = await axiosClient.post(`${AUTOMATIONS}/${automationId}/activate`)
  return data
}
